export default function ValueProposition() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-16 bg-background-100">
      <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
        <div className="flex-1 relative">
          <div className="relative rounded-2xl overflow-hidden aspect-[4/3] lg:aspect-auto lg:h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20desk%20setup%20with%20open%20notebook%20showing%20hand-drawn%20data%20charts%20beside%20a%20tablet%20with%20spreadsheet%20app%2C%20ceramic%20coffee%20cup%2C%20warm%20morning%20light%20through%20linen%20curtains%2C%20organic%20modern%20workspace%2C%20soft%20oatmeal%20and%20clay%20tones%2C%20intimate%20editorial%20style&width=800&height=1000&seq=value-prop-v3d&orientation=portrait"
              alt="Hipobuy Spreadsheet interface de suivi e-commerce"
              title="Interface hipobuy spreadsheet"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute top-4 left-4 flex gap-2 flex-wrap">
              <span className="px-3 py-1.5 bg-background-50/80 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 whitespace-nowrap">
                Automatisé
              </span>
              <span className="px-3 py-1.5 bg-background-50/80 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 whitespace-nowrap">
                E-Commerce
              </span>
              <span className="px-3 py-1.5 bg-background-50/80 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800 whitespace-nowrap">
                2025
              </span>
            </div>
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-center">
          <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
            Hipobuy Spreadsheet – L'outil ultime de suivi e-commerce intelligent
          </h3>
          <div className="mt-5 flex flex-wrap gap-3">
            <span className="px-4 py-1.5 border border-foreground-300 rounded-full text-xs font-medium text-foreground-700 whitespace-nowrap">
              Suivi Produit
            </span>
            <span className="px-4 py-1.5 text-xs font-medium text-foreground-500 whitespace-nowrap">
              Analyse Prix
            </span>
            <span className="px-4 py-1.5 text-xs font-medium text-foreground-500 whitespace-nowrap">
              Dropshipping
            </span>
          </div>

          <div className="mt-8 bg-foreground-950 rounded-2xl p-6 md:p-8">
            <span className="inline-block px-3 py-1 bg-primary-500/20 text-primary-300 rounded-full text-xs font-medium mb-4 whitespace-nowrap">
              Pourquoi Nous
            </span>
            <div className="flex flex-col lg:flex-row gap-6">
              <div className="flex-1">
                <h4 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-3">
                  Une solution avancée de gestion et de suivi des produits
                </h4>
                <p className="text-sm text-foreground-300 leading-relaxed">
                  Le <strong className="text-background-50">Hipobuy Spreadsheet</strong> est conçu pour les vendeurs e-commerce modernes. Il permet de suivre les performances produits en temps réel, d'analyser les prix concurrents automatiquement et d'optimiser les décisions d'achat. Centralisez toutes vos données dans un seul spreadsheet intelligent.
                </p>
              </div>
              <div className="hidden lg:block w-32 h-32 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20bar%20chart%20and%20line%20graph%20abstract%20illustration%20with%20warm%20earthy%20watercolor%20effect%2C%20cream%20paper%20texture%20background%2C%20hand-drawn%20aesthetic%2C%20soft%20terracotta%20and%20sand%20colors%2C%20simple%20elegant%20composition&width=300&height=300&seq=value-chart-v3d&orientation=squarish"
                  alt="Graphique de données hipobuy spreadsheet"
                  title="Analyse hipobuy spreadsheet"
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}